import camelcaseKeys from 'camelcase-keys'
import snakecaseKeys from 'snakecase-keys'

export const camelizeRespDataKeys = ({ data, ...rest }) => ({
  ...rest,
  data: camelcaseKeys(data, { deep: true })
})

export const snakecaseDataKeys = (data) => snakecaseKeys(data, { deep: true })
